<template>
  <div class="card overflow-hidden">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-2 mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
          <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
          <path d="M20 3v4"></path>
          <path d="M22 5h-4"></path>
          <path d="M4 17v2"></path>
          <path d="M5 18H3"></path>
        </svg>
        恋爱占有欲人格类型
      </div>
      <div class="text-center pt-2">
        <div 
          class="w-20 h-20 rounded-full flex items-center justify-center text-5xl mx-auto mb-4"
          :style="{ 
            backgroundColor: hexToRgba(typeData.color, 0.082),
            border: `3px solid ${typeData.color}`
          }"
        >
          {{ typeData.emoji }}
        </div>
        <h3 
          class="text-3xl sm:text-4xl font-bold"
          :style="{ color: typeData.color }"
        >
          {{ typeData.name }}
        </h3>
      </div>
    </div>
    <div class="p-6 pt-0 space-y-6">
      <div class="text-center">
        <p class="text-base leading-relaxed text-gray-600">
          {{ typeData.description }}
        </p>
      </div>
      
      <!-- 核心特征 -->
      <div>
        <h4 class="font-semibold text-sm mb-3 flex items-center gap-2 text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" :style="{ color: typeData.color }">
            <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
            <path d="M20 3v4"></path>
            <path d="M22 5h-4"></path>
            <path d="M4 17v2"></path>
            <path d="M5 18H3"></path>
          </svg>
          核心特征
        </h4>
        <div class="grid grid-cols-2 gap-2">
          <div 
            v-for="(feature, index) in (typeData.characteristics || [])"
            :key="index"
            class="flex items-center gap-2 text-sm px-3 py-2 rounded-lg"
            :style="{ backgroundColor: hexToRgba(typeData.color, 0.03) }"
          >
            <div 
              class="w-1.5 h-1.5 rounded-full flex-shrink-0"
              :style="{ backgroundColor: typeData.color }"
            ></div>
            <span class="text-gray-600">{{ feature }}</span>
          </div>
        </div>
      </div>

      <!-- 优势 -->
      <div>
        <h4 class="font-semibold text-sm mb-3 flex items-center gap-2 text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" :style="{ color: typeData.color }">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
          </svg>
          优势
        </h4>
        <ul class="space-y-2">
          <li 
            v-for="(strength, index) in (typeData.strengths || [])"
            :key="index"
            class="flex items-start gap-2 text-sm text-gray-600"
          >
            <span class="text-green-500 mt-0.5">✓</span>
            <span>{{ strength }}</span>
          </li>
        </ul>
      </div>

      <!-- 挑战 -->
      <div>
        <h4 class="font-semibold text-sm mb-3 flex items-center gap-2 text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" :style="{ color: typeData.color }">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          需要注意
        </h4>
        <ul class="space-y-2">
          <li 
            v-for="(challenge, index) in (typeData.challenges || [])"
            :key="index"
            class="flex items-start gap-2 text-sm text-gray-600"
          >
            <span class="text-orange-500 mt-0.5">⚠</span>
            <span>{{ challenge }}</span>
          </li>
        </ul>
      </div>

      <!-- 建议 -->
      <div class="bg-gradient-to-br from-purple-50 to-blue-50 rounded-xl p-4 border border-purple-100">
        <h4 class="font-semibold text-sm mb-2 flex items-center gap-2 text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" :style="{ color: typeData.color }">
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
          </svg>
          给{{ subjectPronoun }}的建议
        </h4>
        <p class="text-sm text-gray-600 leading-relaxed">
          {{ dynamicAdvice }}
        </p>
      </div>

      <div class="pt-4 border-t border-gray-200">
        <p class="text-xs text-gray-500 text-center leading-relaxed">
          人格类型基于四维度得分综合分析，旨在帮助{{ subjectPronoun }}更好地理解{{ targetPerson }}的占有欲模式。
          每个人都是独特的，类型描述仅供参考。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalityType',
  props: {
    personalityType: {
      type: Object,
      required: true
    },
    rpiScore: {
      type: Number,
      required: true
    },
    assessmentType: {
      type: String,
      default: 'self'
    }
  },
  computed: {
    pronoun() {
      return this.assessmentType === 'self' ? '你的' : 'Ta的'
    },
    subjectPronoun() {
      return this.assessmentType === 'self' ? '你' : 'Ta'
    },
    targetPerson() {
      return this.assessmentType === 'self' ? '自己' : 'Ta'
    },
    dynamicAdvice() {
      if (!this.typeData.advice) return ''
      
      // 根据测评类型动态调整建议文案
      let advice = this.typeData.advice
      
      if (this.assessmentType === 'partner') {
        // 为恋人测模式调整文案
        advice = advice
          .replace(/你的/g, 'Ta的')
          .replace(/你/g, 'Ta')
          .replace(/自己/g, 'Ta')
          .replace(/伴侣/g, '你')
          .replace(/对方/g, '你')
      }
      
      return advice
    },
    typeData() {
      const fallback = {
        color: '#8b5cf6',
        emoji: '❓',
        name: '类型生成中',
        description: '',
        characteristics: [],
        strengths: [],
        challenges: [],
        advice: ''
      }
      const src = this.personalityType || {}
      // 如果缺少 color 等关键字段，使用回退
      return src && src.color ? src : { ...fallback, ...src }
    }
  },
  methods: {
    hexToRgba(hex, alpha) {
      const safe = (h) => {
        if (!h || typeof h !== 'string' || !/^#([0-9a-fA-F]{6})$/.test(h)) return '#8b5cf6'
        return h
      }
      const h = safe(hex)
      const r = parseInt(h.slice(1, 3), 16)
      const g = parseInt(h.slice(3, 5), 16)
      const b = parseInt(h.slice(5, 7), 16)
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }
  }
}
</script>

